import { ChakraFlex, FAIconName, Icon, Text } from '@equip.health/ui';

import { MAI_CHAT_JUMP_TO_LATEST } from './maiChat.constants';

const TOP_LEVEL_ID = 'mai-chat-jump-to-latest';

interface MaiChatJumpToLatestProps {
  onClick: () => void;
}

const MaiChatJumpToLatest = ({ onClick }: MaiChatJumpToLatestProps) => (
  <ChakraFlex
    as="button"
    type="button"
    id={TOP_LEVEL_ID}
    data-testid={TOP_LEVEL_ID}
    onClick={onClick}
    position="absolute"
    bottom="16px"
    left="50%"
    transform="translateX(-50%)"
    zIndex={1}
    alignItems="center"
    gap="6px"
    padding="7px 14px"
    borderRadius="full"
    border="1px solid"
    borderColor="primary.50"
    background="neutral.background.primary"
    boxShadow="0 2px 8px rgba(0, 0, 0, 0.12)"
    cursor="pointer"
    whiteSpace="nowrap"
    transition="150ms"
    _hover={{ background: 'primary.10', borderColor: 'primary.100' }}
  >
    <Text color="primary.100" variant="caption">
      {MAI_CHAT_JUMP_TO_LATEST}
    </Text>
    <Icon name={FAIconName.arrowDownRegular} color="primary.100" size="sm" />
  </ChakraFlex>
);

export default MaiChatJumpToLatest;
